import withState from 'recompose/withState';
import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import debounce from 'lodash/debounce';

import { validatePassword } from '../../auth/actions';

const withValidatePassword = compose(
  withState('validatePasswordWarning', 'setValidatePasswordWarning', ''),
  withHandlers({
    validate: props => debounce((password, kind) => {
      validatePassword(password, kind)
        .then(() => props.setValidatePasswordWarning(''))
        .catch(({ warning, suggestions }) => props.setValidatePasswordWarning([warning, suggestions[0]].join(' ')));
    }, 500),
  }),
  withHandlers({
    validatePassword: props => e => props.validate(e.target.value),
    validatePasswordForUserKind: props => kind => e => props.validate(e.target.value, kind),
  })
);

export default withValidatePassword;
